import React, { useEffect, useState } from 'react';
import '../assets/css/product.css';
import '../assets/css/custom.css';
import bgImage from '../assets/Images/homeBackgroundImg.png';

import API_BASE_URL from "../../helper";

function Product() {

    const [products, setProducts] = useState([]);
    
    // Fetch All Product
    const fetchAllProducts = async () => {
        try {
        const response = await fetch(`${API_BASE_URL}/api/product/all`);
        const data = await response.json();
        setProducts(data);
        } catch (error) {
        console.error("Failed to load Product", error);
        }
    };
    useEffect(() => {
      fetchAllProducts();
    }, []);
    
  return (
  <div>
    <div id="product-hero-section" className="d-flex justify-content-center align-items-center flex-column"
      style={{background: `url(${bgImage}) center/cover no-repeat`}}>
        <h2 className="text-uppercase hero-title">Our Products</h2>
        <p className='hero-subheading'>Smart Digital Solutions for Every Need</p>
    </div>

    <section id='productSection' className='mt-5'>
        <div className='container'>
            <h2 className='text-center'>Our Proudcts</h2>
            <div className='row'>

                {products.length > 0 ? (
                    products.map((product) => (
                    <div className='col-md-4 mb-3'>
                        <div  className='p-3 productDiv position-relative' key={product.id}>
                            <div className='mb-3'>
                                <img src={`${API_BASE_URL}/assets/Images/${product.image}`} alt='loading...'/>
                            </div>
                            <div>
                                <h6 className='text-center fw-bold'>{product.name}</h6>
                                <p>{product.description}</p>
                            </div>
                        </div>
                    </div>
                    ))
                ) : (
                    <p>No Products Available</p>
                )}
            </div>
        </div>
    </section>

  </div>
  )
}

export default Product;